import {
	actionResource,
	attributeResource,
	enumResource,
	getAttributeType,
	getDatePattern,
	getErrorMessage,
	getNameOrUnnamed,
	getNodeName,
	getTimePattern,
	ILocaleProvider,
	numberOfType,
	pathResource,
	resources,
	type,
	viewResource,
} from "designSystem/locale";
import { ComponentItem } from "designSystem/types/component-item-types";

const SUB_RE = /\$\{([^\s\:\}]*)(?:\:([^\s\:\}]+))?\}/g;

const RESOURCES = {
	BackgroundColor: "Background Color",
	ConfirmButton: "Continue",
	ConfirmMessage: "Do you want to continue with the ${0} action?",
	ConfirmPrompt: "${0} Action",
	DateCreated: "Date Created",
	DefaultColor: "Default Color",
	Delete_Confirm: "${0} will be permanently deleted.",
	Delete_NoNodeName: "This will permanently delete the ${0}.",
	Delete_Prompt: "Delete ${0}?",
	FitToScreen: "Fit to Screen",
	FitToWidth: "Fit to Width",
	FormatBold: "Bold",
	FormatItalic: "Italic",
	FormatStrikethrough: "Strikethrough",
	FormatUnderline: "Underline",
	ImageDimension: "Image Dimension",
	ImageIntentLabels: "Labels",
	ImageName: "Image Name",
	ImageType: "Image Type",
	InfoMessage: "This is an info message. Please take it under consideration.",
	Information: "Information",
	ItemsSelected: "${0} items selected",
	ItemsSelectedAll: "All ${0} items selected",
	MoreColors: "More Colors",
	ColorNoFill: "no fill",
	NoLabelAssigned: "No Labels Assigned",
	Placeholder: "I'm placeholder",
	ProgressIndicator: "${0} of ${1}",
	RequestError: "Default Error Title",
	RequestErrorMessage: "Default error message",
	Resource: "${0} Localized Resource",
	Select: "Select",
	SelectAll: "All",
	SelectNone: "None",
	SelectSomething: "Select ${0}",
	ShowCode: "Show Code",
	SuggestedUpperCase: "SUGGESTED",
	ViewPreferences_ImageSize: "Image Size",
};

function resource(res: string, resParams?: Array<number | string>): any {
	const value = RESOURCES[res];

	if (value && resParams) {
		return value.replace(SUB_RE, (match, key, format) => (resParams[key] == null) ? match : resParams[key]);
	}

	return value || res;
}

function getComponentItemName(item: ComponentItem): string {
	return item.name ?? "no name";
}

function getComponentItemSlimName(item: ComponentItem): string {
	const name = getComponentItemName(item);
	const { name2 } = item;
	return name2 ? `${name} | ${name2}` : name;
}

const localeProvider: ILocaleProvider = {
	resources,
	actionResource,
	attributeResource,
	enumResource,
	getAttributeType,
	getComponentItemName,
	getComponentItemSlimName,
	getDatePattern,
	getErrorMessage,
	getNameOrUnnamed,
	getNodeName,
	getTimePattern,
	numberOfType,
	pathResource,
	resource,
	type,
	viewResource,
};

export default localeProvider;